import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const SummaryWrapper = styled('div')`
    .dashboard-page.summary {
        padding-bottom: 80px;
        border-top: 0;
        margin-top: 0;

        .top-container {
            min-height: 120px;
        }

        .page-actions {
            margin-top: 167px;
        }

        .summary-info {
            display: flex;
            flex-direction: column;
            gap: 32px;

            .title {
                font-family: var(--font-family-primary);
                font-weight: var(--font-weight-light);
                font-size: var(--font-size-l);
                line-height: 25px;
                margin-bottom: 10px;
            }

            .summary-issues,
            .summary-assets {
                width: 100%;
            }

            @include at-screen(normal) {
                flex-direction: row;
            }
        }
    }
`

export const TableWrapper = styled('div')<{ theme?: TTheme }>`
    padding: 20px;
    margin-bottom: 32px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 16px;
`
